const autocompleteSize = 5;
const minInputSize = window.tc_vars.env_country.toLowerCase() === 'cn' ? 1 : 3;

const dom = {
  listResult: null,
  listNoResult: null,
};

function filteredItem(storeName, storeLink) {
  return `<li class="storelist__filtered-list__store"><a href="${storeLink}">${storeName}</a></li>`;
}

export function init(listResult, listNoResult) {
  dom.listResult = listResult;
  dom.listNoResult = listNoResult;
}

export function filter(e) {
  // Empty filteredList
  dom.listResult.empty();
  // Hide no-result in all case
  dom.listNoResult.addClass('hidden');

  // Get 'input' (do nothing if imput is empty)
  const input = e.currentTarget ? e.currentTarget.value : '';

  if (input.trim() === '' || input.length < minInputSize) {
    dom.listResult.addClass('hidden');
    return;
  }
  dom.listResult.removeClass('hidden');

  // Get X first corresponding stores, based on 'input'
  const stores = $(`[data-store-name*="${input.toLowerCase()}"]`).slice(
    0,
    autocompleteSize
  );

  // Append Each Stores to the filtered list
  stores.each((index, store) => {
    dom.listResult.append(filteredItem(store.dataset.storeName, store.href));
  });

  // If no store : display 'empty' message
  if (stores.length === 0) {
    dom.listResult.addClass('hidden');
    dom.listNoResult.removeClass('hidden');
  }
}

export function close() {
  dom.listResult.addClass('hidden');
  dom.listNoResult.addClass('hidden');
}



// WEBPACK FOOTER //
// ./src/store/store-list/store-list-autocomplete.js